import { PassedInitialConfig } from 'angular-auth-oidc-client';
import { environment } from '../../../environments/environment';

export const authConfig: PassedInitialConfig = {
  config: {
    authority: environment.authority,
    authWellknownEndpointUrl: environment.authWellknownEndpointUrl,
    redirectUrl: environment.redirectUrl,
    postLogoutRedirectUri: environment.postLogoutRedirectUri,
    clientId: environment.clientId,
    scope: environment.scope,
    responseType: environment.responseType,
    // TODO: Re-enable refresh token after testing token timeout feature
    silentRenew: false, // environment.silentRenew,
    useRefreshToken: false, // environment.useRefreshToken,
    triggerAuthorizationResultEvent: true,
    logLevel: 0, // 0 = LogLevel.Debug for debugging
    historyCleanupOff: false,
    autoUserInfo: true,
    ignoreNonceAfterRefresh: true, // For AWS Cognito compatibility
    silentRenewUrl: window.location.origin + '/assets/silent-renew.html',
  },
};
